"use client";
import React from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import "./CollegeSection.css";

export default function CollegePage() {
  const pathname = usePathname();
  const locale = pathname.split("/")[1];

  return (
    <div className="college-container">
      <h1 className="college-title">College</h1>
      <p className="college-subtitle">
        Explore learning modules to boost your financial skills
      </p>

      <div className="college-banner">
        <h2>Global trading conference</h2>
        <button className="start-button hidden">Start Learning</button>
      </div>

      <div className="module-grid">
        <div className="module-card">
          <div className="module-icon">📘</div>
          <h4>Encyclopedia</h4>
          <p>Financial terms and concepts</p>
          <Link href={`/${locale}/college/encyclopedia`}>
            <button className="explore-btn">Explore</button>
          </Link>
        </div>

        <div className="module-card">
          <div className="module-icon">🎥</div>
          <h4>Course Video</h4>
          <p>Investment strategies</p>
          <Link href={`/${locale}/college/course-video`}>
            <button className="explore-btn">Explore</button>
          </Link>
        </div>

        <div className="module-card">
          <div className="module-icon">📈</div>
          <h4>Industry Report</h4>
          <p>Market trends and analysis</p>
          <Link href={`/${locale}/college/industry-report`}>
            <button className="explore-btn">Explore</button>
          </Link>
        </div>

        <div className="module-card">
          <div className="module-icon">💼</div>
          <h4>Casebase</h4>
          <p>Real-world case studies</p>
          <Link href={`/${locale}/college/casebase`}>
            <button className="explore-btn">Explore</button>
          </Link>
        </div>
      </div>
    </div>
  );
}
